import { render, staticRenderFns } from "./KolPlatform.vue?vue&type=template&id=0ddd4f29&scoped=true"
import script from "./KolPlatform.vue?vue&type=script&lang=js"
export * from "./KolPlatform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddd4f29",
  null
  
)

export default component.exports